import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01v0a2.83 2.83 0 0 1 0-4L17 3",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m16 2 6 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 16H4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "TestTube2";
const TestTube2 = memo(themed(Icon));
export {
  TestTube2
};
//# sourceMappingURL=test-tube-2.js.map
